import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as React from 'react';
import styles from '../styles.module.scss';
export const ContactIsTypingIndicator = () => (_jsxs("div", Object.assign({ className: styles.typingIndicator }, { children: [_jsx("div", { className: styles.typingIndicatorItem }), _jsx("div", { className: styles.typingIndicatorItem }), _jsx("div", { className: styles.typingIndicatorItem })] })));
